if (!customElements.get('stock-warning')) {
  customElements.define(
    'stock-warning',
    class StockWarning extends HTMLElement {
      constructor() {
        super();
        this.stock = parseInt(this.dataset.stock, 10) || 0;
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.bindQuantityInput();

        this.qtyInput?.addEventListener('change', this.updateMessage.bind(this));
        this.qtyInput?.addEventListener('input', this.updateMessage.bind(this));

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;

          const variantId = event.data.variant?.id;

          // ✅ FIX: Read stock from Liquid map — PubSub never includes inventory_quantity
          if (variantId && window.__variantStock__?.[variantId] != null) {
            this.stock = window.__variantStock__[variantId];
          }

          this.bindQuantityInput();
          this.updateMessage();
        });

        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
          this.updateMessage();
        });

        this.updateMessage();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.quantityUpdateUnsubscriber?.();
      }

      bindQuantityInput() {
        this.qtyInput =
          document.getElementById(`Quantity-${this.dataset.section}`) ||
          this.productInfo?.querySelector('.quantity__input');
      }

      updateMessage() {
  if (!this.qtyInput) {
    this.style.display = 'none';
    return;
  }

  const qty = parseInt(this.qtyInput.value, 10) || 1;

  // ✅ Only show when exactly 1 item left AND qty is 1
  if (this.stock === 1 && qty === 1) {
    this.style.display = 'block';
    this.textContent = `HURRY, THERE IS ONLY 1 ITEM LEFT!`;
  } else {
    this.style.display = 'none';
  }
}
    }
  );
}